import Box from '@mui/material/Box';
import ReactMarkdown from 'react-markdown';

/**
 * A Terms / Privacy body. Markdown written by a platform admin; raw HTML in
 * it is not rendered (react-markdown's default), so the text can't carry
 * script or styling of its own.
 */
export function LegalMarkdown({ source }: { source: string }) {
  return (
    <Box
      sx={{
        typography: 'body1',
        lineHeight: 1.65,
        '& h1': { typography: 'h4', mt: 0, mb: 2 },
        '& h2': { typography: 'h5', mt: 4, mb: 1.5 },
        '& h3': { typography: 'h6', mt: 3, mb: 1 },
        '& p, & ul, & ol': { mt: 0, mb: 2 },
        '& li': { mb: 0.5 },
        '& a': { color: 'primary.main' },
        '& table': { borderCollapse: 'collapse', mb: 2, width: '100%' },
        '& th, & td': {
          border: 1,
          borderColor: 'divider',
          p: 1,
          textAlign: 'left',
          verticalAlign: 'top',
        },
      }}
    >
      <ReactMarkdown>{source}</ReactMarkdown>
    </Box>
  );
}
